import React from 'react'
import { Text } from 'oio-react'
import PropTypes from 'prop-types'
import { useGlobalState } from 'src/sites/state'

const Title = ({ children, color, size }) => {
   const { theme } = useGlobalState()

   const textProps = {
      xl: {
         size: theme.tmpTitleXlSize,
         letterSpacing: theme.tmpTitleXlLetterSpacing,
         lineHeight: theme.tmpTitleXlLineHeight,
         transform: theme.tmpTitleXlTransform,
         weight: 'medium'
      },
      lg: {
         size: theme.tmpTitleLgSize,
         letterSpacing: theme.tmpTitleLgLetterSpacing,
         lineHeight: '130%',
         transform: theme.tmpTitleLgTransform,
         weight: 'medium'
      },
      md: {
         size: theme.tmpTitleMdSize,
         letterSpacing: theme.tmpTitleMdLetterSpacing,
         lineHeight: theme.tmpTitleMdLineHeight,
         transform: theme.tmpTitleMdTransform,
         weight: 'medium'
      },
      sm: {
         size: theme.tmpTitleSmSize,
         letterSpacing: theme.tmpTitleSmLetterSpacing,
         lineHeight: theme.tmpTitleSmLineHeight,
         transform: theme.tmpTitleSmTransform,
         weight: 'medium'
      },
      xs: {
         size: theme.tmpTitleXsSize,
         letterSpacing: theme.tmpTitleXsLetterSpacing,
         lineHeight: theme.tmpTitleXsLineHeight,
         transform: theme.tmpTitleXsTransform,
         weight: 'medium'
      }
   }

   return (
      <Text
         color={color || theme.tmpContentTitleColor}
         fontFamily={theme.tmpTitleFontFamily}
         {...textProps[size]}
         style={{ wordWrap: 'break-word' }}>
         {children}
      </Text>
   )
}

Title.propTypes = {
   color: PropTypes.string,
   size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
}

Title.defaultProps = {
   color: undefined,
   size: 'lg'
}

export default Title
